export const c_background_image_BackgroundImage = {
  "name": "--pf-v5-c-background-image--BackgroundImage",
  "value": "none",
  "var": "var(--pf-v5-c-background-image--BackgroundImage)"
};
export default c_background_image_BackgroundImage;